import { Routes, Route, Navigate } from 'react-router-dom'

import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'

import { LoginPage } from './pages/LoginPage'
import { RegisterPage } from './pages/RegisterPage'
import { DashboardLayout } from './pages/DashboardLayout'

import { OverviewPage } from './pages/OverviewPage'
import { CampaignsPage } from './pages/CampaignsPage'
import { CampaignDetailPage } from './pages/CampaignDetailPage'
import { AlertsPage } from './pages/AlertsPage'
import { CreateCampaignPage } from './pages/CreateCampaignPage'
import { FacebookCampaignsPage } from './pages/FacebookCampaignsPage'
import { AnalyticsPage } from './pages/AnalyticsPage'
import { SettingsPage } from './pages/SettingsPage'
import { AdminPage } from './pages/AdminPage'

export function App() {

  return (

    <AuthProvider>

      <Routes>

        {/* DEFAULT REDIRECT */}

        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* LOGIN */}

        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* PROTECTED ROUTES */}

        <Route element={<ProtectedRoute />}>

          <Route element={<DashboardLayout />}>

            {/* DASHBOARD */}

            <Route
              path="/dashboard"
              element={<OverviewPage />}
            />

            {/* CAMPAIGNS */}

            <Route
              path="/dashboard/campaigns"
              element={<CampaignsPage />}
            />

            <Route
              path="/dashboard/campaigns/:id"
              element={<CampaignDetailPage />}
            />

            {/* CREATE CAMPAIGN */}

            <Route
              path="/dashboard/create-campaign"
              element={<CreateCampaignPage />}
            />

            {/* FACEBOOK CAMPAIGNS */}

            <Route
              path="/dashboard/facebook-campaigns"
              element={<FacebookCampaignsPage />}
            />

            {/* ANALYTICS */}

            <Route
              path="/dashboard/analytics"
              element={<AnalyticsPage />}
            />

            {/* ALERTS */}

            <Route
              path="/dashboard/alerts"
              element={<AlertsPage />}
            />

            {/* SETTINGS — Facebook connection */}

            <Route
              path="/settings"
              element={<SettingsPage />}
            />

            {/* ADMIN */}

            <Route
              path="/admin"
              element={<AdminPage />}
            />

          </Route>

        </Route>

        {/* FALLBACK */}

        <Route path="*" element={<Navigate to="/login" replace />} />

      </Routes>

    </AuthProvider>
  )
}